import { createContext, useContext, useEffect, useState } from "react"

const ToolbarContext = createContext()

export const ToolbarProvider = ({ children }) => {
  const [toolbar, setToolbar] = useState([])

  const useChangeOpenPopover = ({ open, value }) => {
    useEffect(() => {
      setToolbar(open ? [...toolbar, value] : toolbar.filter(item => item !== value))
    }, [open, value])
  }

  return (
    <ToolbarContext.Provider value={{ toolbar, setToolbar, useChangeOpenPopover }}>
      {children}
    </ToolbarContext.Provider>
  )
}

export const useToolbar = () => useContext(ToolbarContext)
